import { useParams } from 'react-router-dom';
import { PageTitle } from 'app/components';
import UserLog from './UserLog';

type Params = {
  userId?: string;
};

function UserLogIndex() {
  
  const { userId } = useParams<Params>();

  const titles = [
    "Cadastro",
    { label: "Usuários", route: "/usuario" },
    "LOG de acesso",
  ];

  return (
    <div>
      <PageTitle titles={titles} />
      <UserLog
        userId={userId}
      />
    </div>
  );
}

export default UserLogIndex;
